import { makeStyles } from '@material-ui/core';

import { TableColumn } from '@/config/types';
import { useScreen } from '@/hooks/useScreen';

export const useOtpTable = () => {
  const { isMobile } = useScreen();

  const useStyles = makeStyles({
    root: {
      '& .MuiTableCell-root': {
        paddingInline: 6,
        paddingBlock: 8,
        '&:first-child': {
          paddingLeft: 0,
        },
      },
      '& .MuiTableRow-head': {
        verticalAlign: 'bottom',
      },
      '&. MuiButton-sizeSmall': {
        paddingInline: 2,
        minWidth: 10,
      },
    },
  });

  const classes = useStyles();

  const columnsDesktop: TableColumn[] = [
    { name: 'code', label: 'SENT_CODE_CODE', align: 'left', colWidth: '20%' },
    { name: 'status', label: 'SENT_CODE_STATUS', align: 'left', colWidth: '30%' },
    { name: 'providerName', label: 'SENT_CODE_PROVIDER_NAME', align: 'left', colWidth: '20%' },
    { name: 'date', label: 'SENT_CODE_DATE', align: 'right', colWidth: '30%' },
  ];

  const columnsMobile: TableColumn[] = [
    { name: 'code', label: 'SENT_CODE_CODE', align: 'left', colWidth: '20%' },
    { name: 'status', label: 'SENT_CODE_STATUS_SHORT', align: 'left', colWidth: '20%' },
    { name: 'date', label: 'SENT_CODE_DATE', align: 'right', colWidth: '60%' },
  ];

  const columns = isMobile ? columnsMobile : columnsDesktop;

  return { classes, columns };
};
